import moment from 'moment';

const columnOverrides = [
  {
    field: 'vlrprep',
    valueGetter: ({ value }) =>
      value &&
      value?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
  },
  {
    field: 'vlrexec',
    valueGetter: ({ value }) =>
      value &&
      value?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
  },
  {
    field: 'inivalid',
    valueGetter: ({ value }) => value && moment(value).format('DD/MM/YYYY'),
  },
  {
    field: 'fimvalid',
    valueGetter: ({ value }) => value && moment(value).format('DD/MM/YYYY'),
  },
];

export default columnOverrides;
